module.exports = __webpack_public_path__ + "img/scene5-2.931c6a6b.png";